import React, { FC } from 'react';
import styled from 'styled-components';
import Colours from '../../../design-system/colours';
import Stripe from 'stripe';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import ShoppingBasketIcon from '@mui/icons-material/ShoppingBasket';
import { useTranslation } from 'react-i18next';

interface OvProductTypeSelectorProps {
  type: Stripe.Price.Type;
  onSelect: (type: Stripe.Price.Type) => void;
}

const OvProductTypeSelector: FC<OvProductTypeSelectorProps> = ({
  type,
  onSelect,
}) => {
  const { t } = useTranslation();
  const iconStyle = { width: '2rem', height: '2rem' };

  return (
    <Container>
      <Option
        selected={type === 'one_time'}
        onClick={(e) => {
          e.preventDefault();
          onSelect('one_time');
        }}
      >
        <ShoppingBasketIcon style={iconStyle} />
        <OptionLabel>{t('physicalProducts.dialogs.type.oneTime')}</OptionLabel>
      </Option>

      <Option
        selected={type === 'recurring'}
        onClick={(e) => {
          e.preventDefault();
          onSelect('recurring');
        }}
      >
        <AutorenewIcon style={iconStyle} />
        <OptionLabel>
          {t('physicalProducts.dialogs.type.recurring')}
        </OptionLabel>
      </Option>
    </Container>
  );
};

export default OvProductTypeSelector;

const Container = styled.div`
  display: flex;
  gap: 1rem;
`;

const Option = styled.button<{ selected: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  padding: 1rem;
  border: 2px solid transparent;
  background-color: ${({ selected }) =>
    selected ? Colours.OV_YELLOW : 'transparent'};
  border-radius: 1rem;
  transition: border-color 0.3s;
  flex-basis: 7rem;

  &:hover {
    border-color: ${Colours.OV_YELLOW};
  }
`;

const OptionLabel = styled.span`
  margin-top: 0.5rem;
  font-size: 0.875rem;
  text-align: center;
`;
